(function(){
  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function(){
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var selector = ['.vgc-head', '.vgc-benefit-card', '.vgc-shop-card', '.vgc-ing-card', '.vgc-trust-item', '.vgc-ing-phil-item', '.vgc-cross-card', '.vgc-howto-card', '.vgc-faq-item'].join(',');
    var els = document.querySelectorAll(selector);
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function(el){ el.classList.add('vgc-in-view'); });
      return;
    }

    var groupIndex = {};
    els.forEach(function(el){
      el.setAttribute('data-vgc-animate', '');
      var parent = el.parentElement;
      var key = parent ? (parent.className || 'root') : 'root';
      groupIndex[key] = (groupIndex[key] || 0);
      var delay = Math.min(groupIndex[key], 5) * 0.07;
      el.style.transitionDelay = delay + 's';
      groupIndex[key] += 1;
    });

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('vgc-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });

    els.forEach(function(el){ observer.observe(el); });
  });
})();
